function listData(data, params) {
  const start = (params.page - 1) * params.perPage;
  const end = params.perPage * params.page;
  return data.slice(start, end);
}

export default listData;
